export const MARKET_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure'
} as const

export const DISCLAIMER_TYPE = {
  BEFORE_MARKET_OPEN: 'BeforeMarketOpen',
  PRE_DIVIDEND: 'PreDividend',
  EX_DIVIDEND: 'ExDividend'
} as const

export const ISSUER_NAME_MAP: Record<string, string> = {
  'DOW JONES INDUSTRIAL AVERAGE': 'DJIA',
  'NASDAQ COMPOSITE': 'NASDAQ',
  'S&P 500 INDEX': 'S&P 500',
  'AMERIPRISE FINANCIAL, INC': 'AMP'
}

export const TIME_ZONE = 'America/New_York'
export const TIME_FORMAT = 'MM/dd/yyyy hh:mm a'
